import React from 'react'
import {Link} from 'gatsby'
import ServiceSidebar from './ServiceSidebar'
import imgautomatizacion from '../../assets/images/services/automatizacion.png'
import imgvelocidad from '../../assets/images/services/velocidad.png'
import imgmovilidad from '../../assets/images/services/movilidad.png'
import imgpermisos from '../../assets/images/services/permisos.png'
import imgcifras from '../../assets/images/services/cifras.png'
import imgcomunicacion from '../../assets/images/services/comunicacion.png'
import project2 from '../../assets/images/projects/project2.jpg'
import imgSeguridadMovilidad from '../../assets/images/seguridad-movilidad.png'

const ServiceDetailsContent = (props) => {
    return (
        <section className="services-details-area ptb-100">
            <div className="container">
                <div className="row">
                    <Contenido desde={props.desde} />
                    <div className="col-lg-4 col-md-12">
                        <ServiceSidebar />
                    </div>
                </div>
            </div>
        </section>
    )
}

function Contenido(props) {
    const desde = props.desde;
    switch (desde) {
        case "automatizacion":
            return <div className="col-lg-8 col-md-12">
                <div className="services-details-image">
                    <img src={imgautomatizacion} alt="about" />
                </div>

                <div className="services-details-desc">
                    <span className="sub-title">Integración con otros sistemas</span>
                    <h3>Automatización</h3>
                    <p>La CUSF solicita más de 300 archivos regulatorios… así que podemos coincidir
                        en que generarlos manualmente no sólo es poco práctico, sino casi imposible.
                    </p>

                    <p>La respuesta está en la <b>automatización inteligente</b> de los Reportes Regulatorios.
                        Con ella, <b>¡pueden reducir tiempos, minimizar errores y liberar recursos clave!</b>
                    </p>

                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <div className="image">
                                <img src={project2} alt="about" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="content">
                                <h3>Tipos de automatización</h3>
                                <ul>
                                    <li>Generar múltiples archivos a partir de una sola fuente.</li>
                                    <li>Convertir la salida de sistemas contables, financieros u operativos.</li>
                                    <li>Integrar nuestro sistema con plataformas internas de la empresa.</li>
                                    <li>Enviar resultados automáticamente a sistemas internos o externos.</li>
                                    <li>Completar información con base en fórmulas, reglas y criterios definidos.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        case "comunicacion" :
            return <div className="col-lg-8 col-md-12">
                <div className="services-details-image">
                    <img src={imgcomunicacion} alt="about" />
                </div>

                <div className="services-details-desc">
                    <span className="sub-title">El día a día</span>
                    <h3>Comunicación entre áreas</h3>
                    <p>Olvídate de los correos con la "última-última-ultimaversion.txt".
                        Cuando distintas áreas necesitan intercambiar información, pueden
                        hacerlo directamente a través del sistema.
                    </p>

                    <p>Por ejemplo: el área encargada del R4 requiere el archivo INVE,
                        que otra área carga como parte del Reporte R7. Basta con que se
                        "suscriban" al archivo INVE desde el sistema, y cada vez que se
                        suba una nueva versión —primera, segunda, tercera— <b>recibirán una
                        notificación automática</b>.
                    </p>

                    <p>Así, el usuario puede acceder al módulo R7 (con permisos de sólo
                        lectura asignados por el administrador), descargar el archivo desde
                        ahí y trabajar siempre con la versión más actual y correcta. <b>Sin
                        confusiones, sin duplicados, sin pérdida de tiempo</b>.
                    </p>

                </div>
            </div>
        case "permisos" :
            return <div className="col-lg-8 col-md-12">
                <div className="services-details-image">
                    <img src={imgpermisos} alt="about" />
                </div>

                <div className="services-details-desc">
                    <span className="sub-title">Seguridad y roles</span>
                    <h3>Permisos por usuario</h3>
                    <p>El administrador define con precisión los permisos de cada usuario
                        dentro del sistema. Esto permite crear perfiles con acceso específico:
                        suscribirse a ciertos archivos, descargar otros, subir únicamente los
                        que le corresponden según su área, y más.
                    </p>

                    <p>Así, puedes estar tranquilo: <b>nadie subirá archivos por error ni
                        accederá a información que no le corresponde</b>. Incluso los reportes
                        clave de la compañía estarán disponibles sólo para quienes tengan
                        autorización explícita.
                    </p>

                    <p>¿Y si alguien, por accidente, sube un archivo incorrecto y sobreescribe
                        uno que ya estaba validado? Para empezar, nuestro sistema no permite
                        ese escenario. Pero además, cuenta con una <b>bitácora detallada de accesos
                        y acciones</b>, para saber en todo momento qué se hizo, cuándo y por quién.
                        Ya sabes: "trust, but verify".
                    </p>

                </div>
            </div>
        case "cifras-de-control" :
            return <div className="col-lg-8 col-md-12">
                <div className="services-details-image">
                    <img src={imgcifras} alt="about" />
                </div>

                <div className="services-details-desc">
                    <span className="sub-title">Análisis</span>
                    <h3>Cifras de control</h3>
                    <p>Dentro del sistema desarrollamos un reporte especial llamado <b>Cifras de Control</b>, una <b>versión mejorada del informe que el SEIVE genera al finalizar la carga del R7</b>.
                    </p>

                    <p>La diferencia clave es que nuestro reporte puede ejecutarse
                        conforme se van subiendo los archivos: primero el INVE, luego
                        el CRED, después el CMBG, el CMER, el FOPA… En cada etapa puedes
                        consultar el reporte de <b>Cifras de Control</b> y tomar decisiones
                        informadas, oportunas y estratégicas que pueden representar un ahorro
                        de dinero de forma significativa —<b>sí, muy significativa</b>— para la compañía.
                    </p>

                    <p>Para acceder al reporte, solo dirígete a la sección de <Link to="/gallery" style={{color: '#ff6600', textDecoration: 'none', fontWeight: 'bold'}}>Galería</Link>.
                    </p>

                </div>
            </div>
        case "velocidad" :
            return <div className="col-lg-8 col-md-12">
                <div className="services-details-image">
                    <img src={imgvelocidad} alt="about" />
                </div>

                <div className="services-details-desc">
                    <span className="sub-title">Tiempo de reacción</span>
                    <h3>Velocidad de respuesta</h3>
                    <p>El sistema es rápido, claro. Las computadoras procesan con gran velocidad.
                        Pero no hablamos sólo de eso: si el área contable puede corregir o ajustar
                        archivos (¡porque siempre hay cambios de último momento!) y volver a procesar
                        sin pasar la noche en vela, <b>tendrás un equipo contable mucho más feliz</b>.
                    </p>

                    <p>Y hay más: si necesitas hacer pruebas modificando valores de límites,
                        garantías, reservas, etc., puedes estar tranquilo. <b>Cada cambio tomará
                        cinco, diez minutos en total</b>.
                    </p>
                    
                    <p>¿Qué dices? ¿Que tardan semanas en generar los archivos para el R8? 
                        Lo entendemos. Con nuestro sistema, y haciendo una integración con tus 
                        sistemas / archivos fuente, tardarás sólo horas. <b>Sí, horas</b>.
                    </p>

                </div>
            </div>
        case "movilidad" :
            return <div className="col-lg-8 col-md-12">
                <div className="services-details-image">
                    <img src={imgmovilidad} alt="about" />
                </div>

                <div className="services-details-desc">
                    <span className="sub-title">Siempre en control</span>
                    <h3>Movilidad</h3>
                    <p>Como el sistema corre en cualquier computadora que tenga un navegador
                        (Edge, Internet Explorer, Firefox, Chrome, Safari), no es necesario
                        instalar ningún software especial en las máquinas de tus usuarios,
                        ni aprobar el uso de una computadora en especial. <b>¡Ni siquiera
                        estar en la oficina!</b>
                    </p>
                    
                    <p>Puedes acceder al sistema desde una computadora conectada a internet.
                        Sólo tienes que introducir usuario y contraseña, y listo. Esto, por
                        supuesto, con todas las medidas de seguridad.
                    </p>
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <div className="image" style={{
                                overflow: 'hidden',
                                position: 'relative',
                                width: '100%',
                                height: '400px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <img src={imgSeguridadMovilidad} alt="Seguridad en la nube" style={{
                                    transform: 'scale(1.4)',
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain'
                                }} />
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="content">
                                <h3>Medidas de seguridad</h3>
                                <ul>
                                    <li>Conexión encriptada de extremo a extremo.</li>
                                    <li>Rotación periódica de contraseñas.</li>
                                    <li>Autenticación multifactor (2FA) para todos los accesos.</li>
                                    <li>Servidor en la nube encriptado, protegido y reforzado contra vulnerabilidades.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
    }
    return <div>hola</div>
  }

export default ServiceDetailsContent